import axios from "axios";

const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://go.saffe.ai"
    : "http://localhost:8080";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "x-access-token": localStorage.getItem("@App:token"),
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.dispatchEvent(new CustomEvent('logout'));
    }
    return Promise.reject(error);
  },
);

export default api;
